import apiClient from "@/api/client";

export interface OpsReplicaItem {
  id: number;
  vm_id: number;
  replica_node: string;
  status: string;
  last_sync_at: string | null;
  last_error: string | null;
}

export interface OpsAlertItem {
  id: number;
  severity: string;
  title: string;
  source: string | null;
  created_at: string;
}

export interface OpsScheduleItem {
  id: number;
  vm_id: number;
  cron_expr: string;
  last_run_at: string | null;
}

export interface OpsSummary {
  generated_at: string;
  vms: {
    total: number;
    by_tier_status: Record<string, Record<string, number>>;
  };
  replicas: {
    by_status: Record<string, number>;
    needs_attention: OpsReplicaItem[];
    needs_attention_count: number;
  };
  alerts: {
    by_status_severity: Record<string, Record<string, number>>;
    active_recent: OpsAlertItem[];
  };
  backups: {
    last_24h: Record<string, number>;
    failed_schedules: OpsScheduleItem[];
  };
  lb: {
    enabled_pools: number;
    enabled_backends: number;
  };
}

export async function getOpsSummary(): Promise<OpsSummary> {
  const { data } = await apiClient.get<OpsSummary>("/ops");
  return data;
}
